export default __webpack_public_path__ + "static/media/presales.7bdcdf6c.png";